module.exports = __webpack_public_path__ + "media/newstyle/images/icon-arrow-right-orange-418d689efbd5587dcc201c651cd837e8.svg";